
//-----------------------|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||-----------------------//

export const other = {
    id: 'logout',
    type: 'group',
    children: [
        {
            id: 'masters.view_tblmailreadingstatus',
            title: 'Mail Read Status',
            type: 'item',
            url: '/mail_read_status',
            icon: 'IconMail',
            breadcrumbs: false
        },
        {
            id: 'admin.view_logentry',
            title: 'Logout',
            type: 'item',
            url: '/logout',
            icon: 'IconLogout',
            breadcrumbs: false
        },  
    ]
};
